<template>
  <div class="home">
   <!-- 头部 -->
   <header-view></header-view>
     <!-- <banner ></banner> -->
      <!-- 首页 -->
      <router-view/>
      <!-- 底部 -->
      <footer-view></footer-view>
     </div>
</template>

<script>
// @ is an alias to /src
import FooterView from '@/components/comment/FooterView.vue'
import HeaderView from '@/components/comment/HeaderView.vue'
import Banner from '@/components/comment/Banner.vue'

export default {
  name: 'HomeView',
  components: {
    FooterView,
    HeaderView,
    Banner
  },
  data(){
    return {
      imgList:[],
      menuList:[]
    }
  },
  watch:{
   
  },
  computed:{},
  created(){
   
  },
  mounted(){},
  methods:{
   
  },
}
</script>
<style scoped lang="scss">
.home{
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
</style>
